import React, { useState, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation, useRoute } from '@react-navigation/native';
import { RecipeListParams, Recipe } from '@coffeeplexity/shared';
import { RecipeList } from '../components/recipes/RecipeList';
import { ScrollToTopFAB } from '../components/ui';

export function CreatorRecipesScreen() {
  const theme = useTheme();
  const navigation = useNavigation();
  const route = useRoute();
  const { creatorId } = route.params as {
    creatorId: string;
    creatorName?: string;
  };

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  // Filter recipes by creator_id
  // Note: This requires backend support for filtering by creator_id
  const searchParams: RecipeListParams = {
    filters: {
      creator_id: creatorId,
    },
  };

  const handleRecipePress = useCallback(
    (recipe: Recipe) => {
      (navigation as any).navigate('recipeDetail', { recipeId: recipe.id });
    },
    [navigation]
  );

  const handleScrollToTop = useCallback(() => {
    // RecipeList uses FlatList internally, scroll handled by the list
  }, []);

  const handleScroll = useCallback((event: any) => {
    const yOffset = event.nativeEvent.contentOffset.y;
    setShowScrollToTop(yOffset > 300);
  }, []);

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.colors.background }]}
    >
      {/* Content */}
      <View style={styles.content}>
        <RecipeList
          params={searchParams}
          onRecipePress={handleRecipePress}
          onScroll={handleScroll}
        />
      </View>

      {/* Scroll to Top FAB */}
      <ScrollToTopFAB
        visible={showScrollToTop}
        onPress={handleScrollToTop}
        testID='creator-recipes-scroll-to-top'
      />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
  },
});
